import {Component, inject, OnInit, signal} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {Tab, TabList, TabPanel, TabPanels, Tabs} from 'primeng/tabs';
import {Card} from 'primeng/card';
import {MultiTabStepBaseComponent} from '../../../../../../shared/tabs/multi-tab-step-base.component';
import {TabStatus} from '../../../../../../shared/tabs/tab-status.model';
import {TabStatusDirective} from '../../../../../../shared/tabs/tab-status.directive';
import {
  TenderInvitationPreviewControllerService,
  TenderInvitationPreviewResponse,
  TenderPhaseType,
} from '@frontend/shared-api';
import {
  MAIL_PREVIEW_FIELD_MAP,
  MAIL_PREVIEW_SECTIONS,
  Step82RfpMailPreviewComponent,
} from './step-6-2-rfp-invitation-mail-preview/step-6-2-rfp-invitation-mail-preview.component';
import {
  PROJECT_DESCRIPTION_FIELD_MAP,
  PROJECT_DESCRIPTION_SECTIONS,
  Step82RfpProjectDescriptionComponent,
} from './step-6-2-rfp-project-description/step-8-2-rfp-project-description.component';
import {
  ProjectStepRichTextService,
  calculateRichTextSectionStatus,
} from '../../../../../../shared/services/project-step-rich-text.service';
import {createTabStatusSignal} from '../../../../../../shared/tabs/tab-utils';
import {TabsUnsavedRevealDirective} from '../../../../../../shared/tabs/tabs-unsaved-reveal.directive';

@Component({
  selector: 'app-step-8-2-rfp-invitation-preview',
  providers: [ProjectStepRichTextService],
  imports: [
    TranslocoPipe,
    Tab,
    TabList,
    Tabs,
    TabPanels,
    TabPanel,
    Card,
    Step82RfpMailPreviewComponent,
    Step82RfpProjectDescriptionComponent,
    TabStatusDirective,
    TabsUnsavedRevealDirective,
  ],
  templateUrl: './step-6-2-rfp-invitation-preview.component.html',
})
export class Step62RfpInvitationPreviewComponent
  extends MultiTabStepBaseComponent
  implements OnInit
{
  private readonly tenderInvitationPreviewControllerService = inject(
    TenderInvitationPreviewControllerService,
  );
  protected readonly mailPreviewTabStatus = createTabStatusSignal();
  protected readonly rfpProjectDescriptionTabStatus = createTabStatusSignal();

  invitationPreviewResponse = signal<TenderInvitationPreviewResponse | undefined>(undefined);

  override ngOnInit(): void {
    super.ngOnInit();
    this.loadAllTabData();
  }

  private loadAllTabData(): void {
    this.tenderInvitationPreviewControllerService
      .getTenderInvitationPreview({
        projectId: this.projectId,
        phase: TenderPhaseType.RFP,
      })
      .subscribe({
        next: (data: TenderInvitationPreviewResponse) => {
          this.invitationPreviewResponse.set(data);
          this.calculateInitialTabStatuses();
        },
      });
  }

  private calculateInitialTabStatuses(): void {
    const invitationData = this.invitationPreviewResponse();

    if (invitationData) {
      const richTextCompleted = calculateRichTextSectionStatus(
        invitationData,
        PROJECT_DESCRIPTION_SECTIONS,
        PROJECT_DESCRIPTION_FIELD_MAP,
      );

      const projectDescriptionStatus = {
        totalSections: PROJECT_DESCRIPTION_SECTIONS.length,
        completedSections: richTextCompleted,
      };
      this.onRfpProjectDescriptionStatusChange(projectDescriptionStatus);

      const mailPreviewCompleted = calculateRichTextSectionStatus(
        invitationData,
        MAIL_PREVIEW_SECTIONS,
        MAIL_PREVIEW_FIELD_MAP,
      );

      const mailPreviewStatus = {
        totalSections: MAIL_PREVIEW_SECTIONS.length,
        completedSections: mailPreviewCompleted,
      };
      this.onMailPreviewStatusChange(mailPreviewStatus);
    }
  }

  onMailPreviewStatusChange(status: TabStatus): void {
    this.mailPreviewTabStatus.update(status);
  }

  onRfpProjectDescriptionStatusChange(status: TabStatus): void {
    this.rfpProjectDescriptionTabStatus.update(status);
  }
}
